<div class="outer-container">
  <span class="currentStatusTitile"></span>
  <div class="console-container">
    <div class="input-wrapper">
      <div class="row">
        <h6>This case is currently being worked upon by:</h6>
        <h6>{{message.Name}}</h6>
        <h6>{{message.Email}}</h6>
        <h6>You can view this in read-only mode. Do you want to proceed?</h6>
      </div>
      <div class="text-center">
        <button class="main-btn mt-3 popUpBtn">
          <span (click)="cancelPopup()">Cancel</span>
        </button>
        <button class="main-btn mt-3 popUpBtn">
          <span (click)="proceedWithCaseDetails()">Proceed</span>
        </button>
      </div>
    </div>
  </div>
</div>  
